import React, { useEffect, useMemo, useState } from 'react'
import classNames from 'classnames'

import TmoInput from '../../tmoForms/TmoInput'
import TmoSvg from '../TmoSvg'
import TmoH3 from '../../tmoControlWrappers/TmoH3'
import stringUtils from '../../tmoUtilities/string'
import style from './FilterableList.module.css'
import TmoSelect from '../../tmoForms/TmoSelect'

function FilterableList({
  className,
  renderItem,
  list,
  listClass,
  filterByKey,
  filterByArr,
  placeholder,
  label,
  filteredListLength,
  resultItemName = 'item',
  isUndefinedProperty = false,
  testId
}) {
  const [filterTerm, setFilterTerm] = useState('')
  const [filterByKeyFromArr, setFilterByKeyFromArr] = useState(filterByArr?.[0])

  const filteredList = useMemo(
    () =>
      list?.filter(
        (item) =>
          (isUndefinedProperty &&
            item[filterByKey || filterByKeyFromArr] === undefined) ||
          item[filterByKey || filterByKeyFromArr]
            .toString()
            .toLowerCase()
            .includes(filterTerm.toString().toLowerCase())
      ),
    [list, filterTerm, filterByKey, filterByKeyFromArr, isUndefinedProperty]
  )

  const handleSelectChange = (val) => {
    setFilterByKeyFromArr(val)
    setFilterTerm('')
  }

  useEffect(() => {
    return filteredListLength?.(filteredList.length)
  }, [filteredListLength, filteredList])

  return (
    list.length >= 1 && (
      <div className={classNames(style.container, className)} data-testid={testId} >
        {list.length > 3 && (
          <div
            className={classNames(
              style.input_container,
              style.input_container_inline
            )}
          >
            {label && (
              <TmoH3 className={style.label} flush>
                {label}
              </TmoH3>
            )}
            {filterByArr && (
              <TmoSelect
                selectSpecs={{
                  options: filterByArr?.map((o) => ({
                    value: o,
                    text: stringUtils.prettifyCamelCase(o)
                  }))
                }}
                value={filterByKeyFromArr}
                onChange={(val) => handleSelectChange(val)}
                className={style.select_inline}
              />
            )}
            <TmoInput
              type='text'
              value={filterTerm}
              className={classNames(
                style.input,
                filterByArr && style.input_inline
              )}
              placeholder={placeholder}
              onChange={setFilterTerm}
            />
          </div>
        )}
        {filterTerm && (
          <TmoH3 className={style.results_count}>
            {filteredList.length}{' '}
            {stringUtils.pluralize({
              string: `${resultItemName}`,
              count: filteredList.length
            })}{' '}
            matching:
            <span>
              {filterTerm}
              <TmoSvg
                onClick={() => setFilterTerm('')}
                svgId='x'
                className={style.remove_filter}
              />
            </span>
          </TmoH3>
        )}
        <div className={classNames(style.list, listClass)}>
          {filteredList.map((item) => renderItem(item))}
        </div>
      </div>
    )
  )
}

export default FilterableList
